module.exports = "/_next/static/images/e91c5f825634f856f83ecb1ecf3ba150-website-thumb.jpg";